
  import { Component, Vue } from 'vue-property-decorator'
  import { demoRoutes } from '@/router'
  
  @Component
  export default class DemoHome extends Vue {
    get routePaths() {
      const routes = demoRoutes.navRoutes;
      return routes;
    }
  }
